import { mapActions, mapGetters, mapMutations } from "vuex";
import FacebookWidget from "@/components/widgets/facebook/index.vue";
import GoogleWidget from "@/components/widgets/google/index.vue";

import changeNameForm from "../../components/change-name-form/index.vue";
import agentMoney from "../../components/agent-money/index.vue";
import changeContactForm from "../../components/change-contact-form/index.vue";
import changePasswordForm from "../../components/change-password-form/index.vue";
import addAddressForm from "../../components/add-address-form/index.vue";
import addressForm from "../../components/address-form/index.vue";

export default {
    name: "profile-info",
    data() {
        return {
            isShowAddForm: false,
        };
    },
    head: {
        title: function() {
            return {
                inner: "Точка ",
                separator: "|",
                complement: "Мій кабінет",
            };
        },
    },
    components: {
        "change-name-form": changeNameForm,
        "change-contact-form": changeContactForm,
        "change-password-form": changePasswordForm,
        "add-address-form": addAddressForm,
        "address-form": addressForm,
        FacebookWidget,
        GoogleWidget,
        agentMoney,
    },
    computed: {
        ...mapGetters({
            user: "profile/user",
            addAddressLoading: "profile/addAddressLoading",
            loadingUser: "profile/loadingUser",
        }),
        checkProviderGoogle() {
            return this.user.google;
        },
        checkProviderFacebook() {
            return this.user.facebook;
        },
    },
    created() {
        // if (!this.user) {
        //     this.fetchUserData().then(() => {
        //         // console.log(this.user);
        //     });
        // }
        // setTimeout(()=>{
        //   console.log(this.user);
        // },1000)
    },
    methods: {
        ...mapActions({
            updateUserData: `profile/UPDATE_USER_DATA`,
            fetchUserData: `profile/FETCH_USER_DATA`,
            unlinkGoogle: `profile/UNLINK_WITH_GOOGLE`,
            unlinkFacebook: `profile/UNLINK_WITH_FACEBOOK`,
        }),
        ...mapMutations({
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
        }),
        unlink(name) {
            if (name === "facebook") {
                this.unlinkFacebook().then(() => {
                    this.fetchUserData().then(() => {
                        this.$toasted.success(this.$t("successUnlink"));
                    });
                });
            }
            if (name === "google") {
                this.unlinkGoogle().then(() => {
                    this.fetchUserData().then(() => {
                        this.$toasted.success(this.$t("successUnlink"));
                    });
                });
            }
        },
    },
};
